import {storeEmitter} from "../state/store";

export default {

  beforeEach(to, from, next,store) {
    storeEmitter.emit('close-sm');
    let method = '_before_' + to.name;
    //console.log(method);
    let roles = this[method](store, to.params);
    this._checkRoles(roles, store.user.authorizedUser, next);
  },



  _checkRoles(roles, user, next) {
    if (user == null) {
      if (roles.indexOf('all') < 0  && roles.indexOf('unauthorized') < 0) {
        next('');
      } else {
        next();
      }
    } else {
      let level = user.level.name;
      if (level == 'iphadmin' || level == 'iphuser') {
        if (roles.indexOf('all') < 0 && roles.indexOf(level) < 0) {
          next('welcome');
        } else {
          next();
        }
      } else {
        console.log(level);
        next();
      }

    }



  },

  _before_clearPass(store) {
    store.menuVisible = '';
    store.breadcrumbVisible = false;
    return ['all'];
  },

  _before_udawajPage(store) {
    store.menuVisible = '';
    store.breadcrumbVisible = false;
    return ['all'];
  },

  _before_searchPage(store) {
    store.menuVisible = 'filter';
    store.breadcrumbPath =[{title: "Szukaj", route: null}];
    store.breadcrumbVisible = true;
    return ['iphadmin', 'iphuser'];
  },

  _before_welcomePage(store){
    store.menuVisible = 'mobile';
    store.breadcrumbPath=[];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },

  _before_cart(store) {
    store.menuVisible = 'filter';
    store.breadcrumbPath = [{title: "Koszyk", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },

  _before_offerConf(store) {
    store.menuVisible = 'filter';
    store.breadcrumbPath =[{title: "Konfiguracja oferty", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },



  _before_productPage(store) {
    store.menuVisible = 'filter';
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },

  _before_orderForm(store) {
    store.menuVisible = 'mobile';
    store.breadcrumbPath =[{title: "Koszyk", route: "/cart"}, {title: "Twoje zamówienie", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },



  _before_showPage(store) {
    store.menuVisible = '';
    store.breadcrumbPath =[];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
    return ['all'];
  },

  _before_contact(store) {
    store.menuVisible = '';
    store.breadcrumbPath =[];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
    return ['all'];
  },

  _before_mainPage(store) {
    store.menuVisible = '';
    store.breadcrumbPath =[];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
    return ['all'];
  },

  _before_userRestorePassword(store) {
    store.menuVisible = '';
    store.breadcrumbPath =[];
    store.breadcrumbVisible = false;
    store.showRightWindow = false;
    return ['all'];
  },

  _before_account(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Ustawienia konta", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['all'];
  },

  _before_addresses(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Adresy dostawy", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },




  _before_addAddress(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Adresy dostawy", route: '/account/addresses'}, {title: "Dodaj adres dostawy", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },

  _before_users(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Lista użytkowników", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },


  _before_user(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Nowy użytkownik", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
  },

  _before_orders(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Lista zamówień", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },

  _before_orderPage(store, params) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Lista zamówień", route: "/account/orders"}, {title: "Zamówienie nr " + params.orderId, route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },

  _before_offerList(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Lista ofert", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },

  _before_offerPage(store, params) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Lista ofert", route: "/account/offers"}, {title: "Oferta nr " + params.offerId, route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },


  _before_budgets(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Budżety", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },

  _before_invoices(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Faktury", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },

  _before_addBudget(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Budżety", route: '/account/budgets'}, {title: "Dodaj budżet", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },

  _before_user(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Nowy użytkownik", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },

  _before_mpks(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Miejsca powstawania kosztów", route: null}];

    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },

  _before_addMpk(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Miejsca powstawania kosztów", route: '/account/mpks'}, {title: "Dodaj MPK", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },

  _before_settings(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Ustawienia", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin', 'iphuser'];
  },

  _before_stats(store) {
    store.menuVisible = 'account';
    store.breadcrumbPath =[{title: "Sprzedaż", route: null}];
    store.breadcrumbVisible = true;
    store.showRightWindow = false;
    return ['iphadmin'];
  },


}




// WEBPACK FOOTER //
// ./src/router/RouterEvent.js